import { render, staticRenderFns } from "./GastosProveedorV2.vue?vue&type=template&id=00d1b04b&"
import script from "./GastosProveedorV2.vue?vue&type=script&lang=js&"
export * from "./GastosProveedorV2.vue?vue&type=script&lang=js&"
import style0 from "./GastosProveedorV2.vue?vue&type=style&index=0&id=00d1b04b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports